import React from 'react';
import { Box } from '@mui/material';
import RelatedSectionShell, { TilesGrid } from './RelatedSectionShell';

// Use the same tile component you use on the dashboard for Desired Outcomes
import SituationTile from '../tiles/SituationTile';

import DesiredOutcomesTable from './tables/DesiredOutcomesTable';

const findDesiredOutcomesSection = (sections) =>
  (sections || []).find((s) =>
    s?.title && /what are the top desired outcomes/i.test(String(s.title))
  ) || null;

const sectionTotalFrom = (sec) =>
  sec?.section_total_interviews ?? sec?.sectionTotal ?? 0;

export default function RelatedDesiredOutcomes({ sections, customerStories = [], jobName }) {
  const desiredSec = React.useMemo(() => findDesiredOutcomesSection(sections), [sections]);
  if (!desiredSec) return null;

  const tiles = Array.isArray(desiredSec.tiles) ? desiredSec.tiles : [];
  const top3 = tiles.slice(0, 3);

  return (
    <RelatedSectionShell section={desiredSec}>
      {/* Top-3 tiles (same visuals as dashboard) */}
      <Box sx={{ mb: 2 }}>
        <TilesGrid
          tiles={top3}
          renderTile={(t) => (
            <SituationTile {...t} sectionTotal={sectionTotalFrom(desiredSec)} />
          )}
        />
      </Box>

      {/* Full ranked table with expandable per-interview rows */}
      <DesiredOutcomesTable
        rowsSource={tiles}
        customerStories={customerStories}
        jobName={jobName}
      />
    </RelatedSectionShell>
  );
}
